module.exports = __webpack_public_path__ + "img/zzf_board_person3.6ee80cf0.png";